// extracted by mini-css-extract-plugin
export default {"container":"MainCard_container__KlMX+"};